var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "generic-assigner-wrapper" },
    [
      _setup.showFilters
        ? _c(_setup.VairantFilters, {
            staticClass: "mb-2",
            attrs: {
              "allow-multiple-select": _setup.isFinalStep,
              filters: _setup.getCurrentStepFilters(),
              "disable-actions": _setup.isLoading,
            },
            on: { search: _setup.onFiltersChange },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_setup.isVariantPickerOpen,
              expression: "!isVariantPickerOpen",
            },
          ],
        },
        [
          _c(
            "keep-alive",
            [
              _setup.isLoading
                ? _c(
                    "div",
                    { staticClass: "text-center" },
                    [
                      _c("b-spinner", {
                        staticClass: "my-2",
                        attrs: { variant: "primary" },
                      }),
                    ],
                    1
                  )
                : _c(_setup.currentStep, {
                    tag: "component",
                    attrs: {
                      products: _setup.catalog.products,
                      "template-product": _setup.templateProduct,
                      "selected-product": _setup.selectedProviderProduct,
                      "provider-placeholders":
                        _setup.selectedProviderProduct.placeholders,
                      "template-product-placeholders":
                        _setup.templateProduct.placeholders || [],
                      provider: _setup.props.podProvider,
                    },
                    on: {
                      "product-select": _setup.onProductSelected,
                      "placeholder-selected": _setup.onPlaceholderSelected,
                      "open-variant-matcher": (...args) =>
                        _setup.variantMatch(args[0], args[1]),
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "header-actions",
                        fn: function () {
                          return [
                            _setup.catalog.fetchLimit
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-info",
                                    on: { click: _setup.onManualFetchProducts },
                                  },
                                  [
                                    _vm._v(
                                      "\n                        Fetch Products\n                    "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "actions-container" },
            [
              _setup.isInitialStep
                ? [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-secondary",
                        on: { click: _setup.onCancelHandler },
                      },
                      [_vm._v("Cancel")]
                    ),
                  ]
                : [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-secondary",
                        attrs: { disabled: _setup.isLoading },
                        on: { click: _setup.onBackHandler },
                      },
                      [_vm._v("Back")]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary",
                        attrs: { disabled: _setup.isNextDisabled },
                        on: { click: _setup.onNextHandler },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_setup.isFinalStep ? "Save" : "Next") +
                            "\n                "
                        ),
                      ]
                    ),
                  ],
            ],
            2
          ),
        ],
        1
      ),
      _vm._v(" "),
      _setup.isVariantPickerOpen
        ? [
            _setup.isLoading
              ? _c(
                  "div",
                  { staticClass: "text-center" },
                  [
                    _c("b-spinner", {
                      staticClass: "my-2",
                      attrs: { variant: "primary" },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(_setup.VariantPicker, {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_setup.isLoading,
                  expression: "!isLoading",
                },
              ],
              attrs: { "selected-product": _setup.selectedProviderProduct },
              on: {
                "variant-selected": _setup.onVariantSelected,
                cancel: _setup.closeVariantPicker,
              },
            }),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }